import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "2 2 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 12v-2h7v2zm0-4V6h11v2zm0-4V2h11v2zm7 14v-3.075l5.525-5.5a1.364 1.364 0 0 1 .5-.325 1.6 1.6 0 0 1 .55-.1 1.5 1.5 0 0 1 .575.112 1.516 1.516 0 0 1 .5.338l.925.925a1.739 1.739 0 0 1 .313.5 1.443 1.443 0 0 1 .113.55 1.706 1.706 0 0 1-.1.563 1.342 1.342 0 0 1-.325.513l-5.5 5.5zm7.5-6.575-.925-.925zm-6 5.075h.95l3.025-3.05-.45-.475-.475-.45-3.05 3.025zm3.525-3.525-.475-.45.925.925z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "EditDate"}) } }